module.exports = __webpack_public_path__ + "static/media/imagecutout_removebackground.20a1444b.png";